import { Image } from 'react-native';
import React, { useState } from 'react';
import { ThemedView, ThemedText } from '@app/theme';
import Button from '@app/sharedComponents/Button/Button';
import AsyncStorage from '@react-native-async-storage/async-storage';
import axios from 'axios';
import { endpoints } from '@app/api/apis';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '@app/store/hooks';
import { showErrorSheet } from '@app/store/slices/errorSlice';
import { getNextRoute } from '@app/navigationApp/navigationUtil';
import { getEnabledRTA } from '@app/screens/KYCStepper/services/service';
import { updateLinkedApplication } from '@app/store/slices/authSlice';

export const bookTransferV2Api = async (payload: { creditId: string }) => {
  const response = await axios.get(endpoints.bookTransferV2 + 'allowed/credit/' + payload.creditId);
  return response.data;
}

const ElevateContinueCardTata = ({ navigation , elevateDetails }: { navigation: any , elevateDetails: any}) => {


  const dispatch = useDispatch();
  const creditId = useAppSelector(state => state?.auth?.userDetails?.linkedCredits[0]?.creditId)

  const [isLoading, setIsLoading] = useState(false)





  const handleElevateContinue = async () => {
    setIsLoading(true)
    try {
      const response = await bookTransferV2Api({ creditId: creditId });
      const newDspApplicationId = response?.creditApplication?.applicationId
      await AsyncStorage.setItem('application_id', newDspApplicationId)
      await AsyncStorage.setItem('isElevate', "true")
      AsyncStorage.setItem("newUserElevateData", JSON.stringify(elevateDetails?.creditApplication))
      const currentStepId = response?.creditApplication?.currentStepId
      dispatch(updateLinkedApplication(response?.creditApplication))
      if (
        currentStepId === 'MF_FETCH_PORTFOLIO' ||
        currentStepId === 'MF_PLEDGE_PORTFOLIO'
      ) {
        const enabledRTAFlowResponse = await getEnabledRTA({applicationId : newDspApplicationId})
        const isFromMFCentral =
          enabledRTAFlowResponse?.enabledRtaFlow === "MfCentralFlow"
        const mfcFetchStatus = enabledRTAFlowResponse?.mfcFetchStatus

        if (mfcFetchStatus === 'IN_PROGRESS') {
          navigation.navigate("MFC_FETCH_EVALUTE_FUNDS")
          return 
        } else if (
          isFromMFCentral &&
          currentStepId === "MF_PLEDGE_PORTFOLIO"
        ) {
          navigation.navigate("MFC_FETCH_ANCHOR")
          return
        } else if (
          isFromMFCentral &&
          currentStepId === "MF_FETCH_PORTFOLIO"
        ) {
          navigation.navigate("MF_FETCH_PORTFOLIO")
          return
        } else if (!isFromMFCentral) {
          const determinedStep = getNextRoute(currentStepId, response?.creditApplication?.applicationState, response?.creditApplication?.stepStatusMap)
          navigation.navigate(determinedStep)
        }
      } else {
        const determinedStep = getNextRoute(currentStepId, response?.creditApplication?.applicationState, response?.creditApplication?.stepStatusMap)
        navigation.navigate(determinedStep)
      }
    } catch (err: any) {
      dispatch(showErrorSheet({
        isErrorSheetVisible: true,
        errorMessage: err?.data?.message,
        closeOnBackdropPress: true,
        errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
        errorHeading: err?.data?.header,
        showErrorHeading: true,
        btnName: 'Ok, got it!',
      }))
    } finally {
      setIsLoading(false)
    }
  }
  return (
    <ThemedView backgroundColor='bg-surface-primary' borderRadius='lg' flexDirection='row' overflow='hidden' mx="lg" mt="lg">
      <ThemedView flex={1} px="lg" py="2xl">
        <Image style={{ height: 18, width: 90, marginBottom: 16 }} resizeMode={'contain'} source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/dsp_logo.png" }} />
        <ThemedText variant="h4s" color="text-primary" mb="sm" >Complete loan application journey</ThemedText>
        <ThemedText variant="b4r" color="text-secondary" mb="sm" >You’re almost there, just a few more steps to go.</ThemedText>
        <Button buttonLoader={isLoading} handlePress={handleElevateContinue} label="Continue" size='MD' type='OUTLINED' />
      </ThemedView>
      <Image style={{ height: 119, width: 160, alignSelf: "flex-end", position: 'absolute', right: 0, top: 0 }} source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/dsp_round_bg.png" }} />
    </ThemedView>
  );
};

export default ElevateContinueCardTata;

